<template>
  <v-app>
    <v-content class="d-flex justify-center align-center mx-auto" style="max-width: 40vw">
      <div style="max-width: 40vw">
        <div v-if="loading" class="mx-auto text-center">
          <v-card-text>
            <v-progress-circular
                indeterminate
                color="primary"
                :size="180"
                :width="10"
            ></v-progress-circular>
          </v-card-text>
          <v-card-text class="subtitle-1 mt-4 pb-0">Please wait</v-card-text>
          <v-card-text class="font-weight-bold headline pt-0">Checking payment</v-card-text>
          <v-card-text class="d-flex align-center">
            <img :src="logoUrl" alt="avatar" class="mr-5" style="width: 300px">
            <img :src="sarkarLogo" alt="avatar" style="width: 100px;">
          </v-card-text>
        </div>

        <div v-else class="d-flex flex-column align-center">
          <img :src="statusImg" class="status-img mb-5"/>

          <div class="text-center">
            <div v-if="paymentSuccess">
              <div class="font-weight-bold text--red headline mb-0">Payment Success</div>
              <div class="font-weight-medium blue-grey--text text--darken-3 subtitle-1">
                Your amount <span v-if="$route.query.ebpNo" class="ml-1">for voucher number:
                <b>{{ $route.query.ebpNo }}</b></span> has been paid and the application has been received!
              </div>
              <v-alert :value="true" class="hide-on-print text-black mt-4 text-left" type="success" outlined>
                Your amount has been paid and the application has been received! <br>
                For further inquiry, please mail at <b>info@immigration.gov.np</b> or call at <b>+977-01-4429659</b>
              </v-alert>
            </div>

            <div v-else>
              <div class="font-weight-bold warning--text headline mb-0">Payment Acknowledgement Pending</div>
              <div class="font-weight-medium blue-grey--text text--darken-3 subtitle-1">
                Your amount <span v-if="$route.query.ebpNo" class="ml-1">for voucher number:
                <b>{{ $route.query.ebpNo }}</b></span> has been received!
              </div>
              <v-alert :value="true" class="hide-on-print text-black mt-4 text-left" type="warning" outlined>
                Sometimes it takes about 5-30 minutes to enter the successful voucher. <br>
                For further inquiry, please mail at <b>info@immigration.gov.np</b> or call at <b>+977-01-4429659</b>
              </v-alert>
            </div>
          </div>

<!--          <v-btn color="primary" large dressed @click="moveToApplyAgain" class="my-4">Apply again</v-btn>-->
          <v-btn color="primary" large dressed @click="moveToCheckPayment" class="my-4">Check Payment</v-btn>
          <div class="d-flex align-center">
            <img :src="logoUrl" alt="avatar" class="mr-5" style="width: 300px">
            <img :src="sarkarLogo" alt="avatar" style="width: 100px;">
          </div>
        </div>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import {API_URL, VERSION} from "../../config/config";
import Http from 'axios';
import {NEPAL_SARKAR_LOGO, NEPALIPORT_LOGO_URL} from "@/constant/appConstant";

export default {
  name: "GovPaySuccess",
  data() {
    return {
      sarkarLogo: NEPAL_SARKAR_LOGO,
      logoUrl: NEPALIPORT_LOGO_URL,
      printContent: {},
      statusImg: require('@/assets/successful.png'),
      paymentSuccess: false,
      loading: true,
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name && (from.name === 'OnArrival' || from.name === 'OnlineApplication' || from.name === 'OnArrival')) {
      next(vm => {
        vm.$router.push({
          name: 'OnlineApplication'
        })
      })
    }
    next();
  },
  methods: {
    moveToApplyAgain() {
      let routeData = this.$router.resolve({name: 'HomePage'});
      window.open(routeData.href, '_self');
    },
    moveToCheckPayment(){
      window.location.href = "https://nepaliport-new.immigration.gov.np/card-payment";
    },
    checkPaymentStatus() {
      const {ebpNo, hashValue} = this.$route.query

      Http.post(`${API_URL}${VERSION}/public-check-payment-status/`, {
        update: true,
        voucher_no: ebpNo,
        hashValue: hashValue
      }).then((res) => {
        this.printContent = res.data;
        this.paymentSuccess = res.data.status
      }).catch(err => {
        this.paymentSuccess = false;
      }).finally(() => {
        this.loading = false;
      })
    }
  },
  mounted() {
    this.checkPaymentStatus();
  }
}
</script>


<style>
#printContent {
  display: none;
}

@media print {
  .hide-on-print {
    display: none;
  }


  #printContent {
    display: block;
  }
}

.status-img {
  height: 200px;
}
</style>


